export default __webpack_public_path__ + "static/media/glitch31.284bca44.png";